export const queryKeys = {
  // Projects
  projects: {
    all: ['projects'] as const,
    list: () => [...queryKeys.projects.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.projects.all, 'detail', id] as const,
    participants: (projectId: string) => [...queryKeys.projects.all, 'participants', projectId] as const,
    monthlyData: (projectId: string, month?: string) => [...queryKeys.projects.all, 'monthlyData', projectId, month] as const,
    dashboard: (projectId: string) => [...queryKeys.projects.all, 'dashboard', projectId] as const,
  },

  // Users
  users: {
    all: ['users'] as const,
    list: () => [...queryKeys.users.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.users.all, 'detail', id] as const,
  },

  // Messages
  messages: {
    all: ['messages'] as const,
    conversations: () => [...queryKeys.messages.all, 'conversations'] as const,
    conversation: (id: string) => [...queryKeys.messages.all, 'conversation', id] as const,
    unreadCount: () => [...queryKeys.messages.all, 'unreadCount'] as const,
  },

  // Transactions
  transactions: {
    all: ['transactions'] as const,
    list: (filters?: object) => [...queryKeys.transactions.all, 'list', filters] as const,
    detail: (id: string) => [...queryKeys.transactions.all, 'detail', id] as const,
  },

  // Groups
  groups: {
    all: ['groups'] as const,
    list: () => [...queryKeys.groups.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.groups.all, 'detail', id] as const,
    users: (groupId: string) => [...queryKeys.groups.all, 'users', groupId] as const,
  },
};
